const countriesLangauges = {
  en: 'English',
  fr: 'French',
  nl: 'Dutch',
};

export default countriesLangauges;
